import React, { useCallback, useMemo } from 'react';

import { SUBCATEGORIES } from '../../common/categories';
import { OKTA_CONNECTORS_FIELDS } from '../../common/fields';
import * as actions from '../../containers/Integrations/integrationsActions';

import TextInput from '../Controls/TextInput/TextInput';
import OktaConnector from './OktaConnector';
import { useGetTabDisplay } from '../../hooks/lockedFeatures/useTabDisplay';
import { SettingsFeatureLock } from '../LockedFeatures/SettingsFeatureLock';

const { OKTA_CONNECTORS } = SUBCATEGORIES;
const { OKTA_REDIRECT_URI, OKTA_BRIDGE_CONNECTOR } = OKTA_CONNECTORS_FIELDS;

const OktaConnectors = ({ fields, dispatch, authorizePermission }) => {
    const redirectUri = fields[OKTA_REDIRECT_URI.ID];
    const bridgeConnector = fields[OKTA_BRIDGE_CONNECTOR.ID];
    const { enabled } = useGetTabDisplay(OKTA_CONNECTORS.ID);
    const disabled = useMemo(() => !authorizePermission || !enabled, [authorizePermission, enabled]);

    const dispatchUpdate = useCallback(
        (fieldId, value) => {
            dispatch({
                type: actions.UPDATE_CONNECTORS_FIELDS,
                payload: { tabKey: OKTA_CONNECTORS.ID, fieldId, value }
            });
        },
        [dispatch]
    );

    const dispatchUpdateArray = useCallback(
        (fieldId, index, arrFieldId, value) => {
            dispatch({
                type: actions.UPDATE_CONNECTOR,
                payload: { tabKey: OKTA_CONNECTORS.ID, fieldId, index, arrFieldId, value }
            });
        },
        [dispatch]
    );

    return (
        <>
            {redirectUri && (
                <SettingsFeatureLock id={SUBCATEGORIES.OKTA_CONNECTORS.ID} isTabId={true}>
                    <TextInput field={redirectUri} changed={dispatchUpdate} disabled={disabled} />
                </SettingsFeatureLock>
            )}
            {bridgeConnector && (
                <OktaConnector
                    oktaConnector={bridgeConnector.value[0]}
                    changedFunc={(fId, v) => dispatchUpdateArray(OKTA_BRIDGE_CONNECTOR.ID, 0, fId, v)}
                    disabled={disabled}
                />
            )}
        </>
    );
};

export default React.memo(OktaConnectors);
